import React from "react";
import { SovosBox, SovosButton, SovosTypography } from "mosaic-react";
import { SovosAIIcon } from "mosaic-react-platform";
import { AI_BRAND_GRADIENT_PINK } from "mosaic-react-platform/shared/aiBrandGradient";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const SoviSuggestionsBanner = ({
    fixCount,
    onReviewRules,
    onReviewSuggestions,
    ruleCount,
}) => {
    const { i18n } = useGlobalValue();
    const fixLabel = fixCount === 1 ? i18n`fix` : i18n`fixes`;
    const ruleLabel = ruleCount === 1 ? i18n`rule` : i18n`rules`;

    return (
        <SovosBox
            sx={{
                alignItems: "center",
                bgcolor: `${AI_BRAND_GRADIENT_PINK}14`,
                borderRadius: 1,
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                justifyContent: "space-between",
                px: 2,
                py: 1.5,
            }}
        >
            <SovosBox sx={{ alignItems: "center", display: "flex", gap: 1.5 }}>
                <SovosBox
                    sx={{
                        alignItems: "center",
                        display: "flex",
                        "& svg": { height: 24, width: 24 },
                    }}
                >
                    <SovosAIIcon />
                </SovosBox>
                <SovosTypography variant="body2">
                    {i18n`Sovi AI has suggested ${fixCount} ${fixLabel} and ${ruleCount} ${ruleLabel}, you can accept them or ignore them.`}
                </SovosTypography>
            </SovosBox>
            <SovosBox sx={{ alignItems: "center", display: "flex", gap: 1 }}>
                <SovosButton size="small" variant="text" onClick={onReviewSuggestions}>
                    {i18n`Review suggestion`}
                </SovosButton>
                <SovosButton size="small" variant="text" onClick={onReviewRules}>
                    {i18n`Review rules`}
                </SovosButton>
            </SovosBox>
        </SovosBox>
    );
};

export default SoviSuggestionsBanner;
